<template>
  <PlatformLayout layout-class="mainStyle" title="Заявки на обсуждение" :show-guest-banner="false">
            <div class="meetings">
  <table class="meeting-table">
    <thead>
      <tr>
        <th>
            <input 
                type="checkbox"
                :checked="isAllSelected"
                @change="toggleSelectAll"
            />
        </th>
        <th>Пользователь</th>
        <th>Статус</th>
        <th>Дата</th>
        <th>
            <img 
                src="@/assets/icons/delete.svg" 
                v-show="selectedMeetings.length > 0" 
                @click="deleteSelected()" 
                style="height: 1.25rem; width: 20px; cursor: pointer;"
                title="Удалить выбранные заявки"
            />
        </th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="meeting in meetings" :key="meeting.id">
        <td>
            <input 
                type="checkbox"
                :checked="selectedMeetings.includes(meeting.id)"
                @change="toggleSelect(meeting.id)" 
            />
        </td>
        <td style="display: flex; align-items: center; gap: 20px;">
            <div class="user-info">
                <img
                    :src="meeting.user.image_url || meeting.user.default_profile_image_url"
                    alt="Фото"
                    class="avatar"
                />
                <p>{{ meeting?.user?.id }}</p>
            </div>
            <div class="user-name">
                <p @click="$router.push(`/curator/users/${meeting?.user?.id}?isFav=true`)">{{ meeting.user.surname }} {{ meeting.user.name }}</p>
            </div>
        </td>
        <td>
            <span
                :class="[
                'status',
                meeting.status_id === 1 ? 'status--created' :
                meeting.status_id === 2 ? 'status--pending' :
                meeting.status_id === 3 ? 'status--confirmed' :
                meeting.status_id === 4 ? 'status--rejected' : ''
                ]"
            >
                {{ meeting.status }}
            </span>
        </td>
        <td>{{ meeting.created_at }}</td>
        <td class="delete" @click="deleteMeeting(meeting.id)">
            <img src="@/assets/icons/delete.svg" style="height: 1.25rem;"/>
        </td>
      </tr>
    </tbody>
  </table>
</div>
  </PlatformLayout>
</template>

<script>
import PlatformLayout from "@/components/platform/PlatformLayout.vue";
import { Swiper, SwiperSlide, } from "swiper/vue";
import { mapActions, mapGetters } from "vuex";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/effect-coverflow";
import { useHead } from "@vueuse/head"
import SwiperCore, { A11y, Autoplay } from "swiper";
import { Navigation, Pagination, EffectCoverflow } from 'swiper';
import "swiper/swiper.min.css";
import EditCurator from "@/components/newPlatform/editCurator.vue";
SwiperCore.use([Navigation, Pagination, A11y, Autoplay, EffectCoverflow])
import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
import axios from "axios";
export default {
    components: {
        Swiper,
        SwiperSlide,
        PlatformLayout,
    },
    data() {
        return {
            meetings: [],
            selectedMeetings: [],
        };
    },
    methods: {
        async getRequests() {
            await axios.get(`/platform/expert/meetings`, {
            headers: {
                    Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                }
            })
            .then(res => {
                this.meetings = res.data.data
            })
            .catch(err => {
            })  
        },
        deleteMeeting(id) {
            if (!window.confirm("Вы уверены, что хотите удалить эту заявку?")) {
                return; // отмена
            }
            const formData = {
                id: id,
            }
            axios.post(`/platform/expert/delete_meetings`, formData, {
                headers: {
                Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                }
            })
            .then(res => {
                this.getRequests();
                toast.success('Заявка успешно удалена');
            })
            .catch(err => {
                toast.error('Ошибка при удалении заявки');
            });
        },
        formatDateTime(dateStr) {
        const options = {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        };
        return new Date(dateStr).toLocaleString('ru-RU', options);
        },
        toggleSelectAll() {
            if (this.isAllSelected) {
                this.selectedMeetings = [];
            } else {
                this.selectedMeetings = this.meetings.map(meeting => meeting.id);
            }
        },
        toggleSelect(id) {
            const index = this.selectedMeetings.indexOf(id);
            if (index === -1) {
                this.selectedMeetings.push(id);
            } else {
                this.selectedMeetings.splice(index, 1);
            }
        },
        deleteSelected() {
            if (this.selectedMeetings.length === 0) {
                toast.error('Выберите заявки для удаления');
                return;
            }
            if (!window.confirm("Вы уверены, что хотите удалить выбранные заявки?")) {
                return; // отмена
            }
            
            const requests = this.selectedMeetings.map(id => {
                return axios.post(`/platform/expert/delete_meetings`, { id }, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                }
                });
            });

            Promise.allSettled(requests).then(results => {
                const successCount = results.filter(r => r.status === 'fulfilled').length;
                const failedCount = results.length - successCount;

                if (successCount > 0) {
                toast.success(`Удалено ${successCount} заявок`);
                }
                if (failedCount > 0) {
                toast.error(`Не удалось удалить ${failedCount} заявок`);
                }

                // Обновляем список и сбрасываем выделение
                this.getRequests();
                this.selectedMeetings = [];
            });
        }
    },
    computed:{
        isAllSelected() {
            return this.meetings.length > 0 && this.selectedMeetings.length === this.meetings.length;
        }
    },
    async created() {
        this.getRequests();
    },
};
</script>

<style lang="scss" scoped>
.delete{
    img{
        width: 20px !important;
    }
}
.user-info{
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 5px;
}
.status {
    padding: 4px 8px;
    border-radius: 8px;
    font-size: 0.875rem;
    font-weight: 500;
  }
.meeting-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
  cursor: pointer;
  th, td {
    padding: 12px 16px;
    text-align: left;
    border-bottom: 1px solid #ddd;
    img{
        width: 50px;
    }
  }

  th {
    background-color: #f3f4f6;
    font-weight: 600;
    color: #333;
  }

  tr:hover {
    background-color: #f9fafb;
  }

  .status {
  padding: 4px 8px;
  border-radius: 8px;
  font-size: 0.875rem;
  font-weight: 500;
  display: inline-block;
  min-width: 90px;
  text-align: center;
}

/* Статус: Не начато (id = 1) — синий */
.status--created {
  background-color: #e0f2fe;
  color: #0284c7;
}

/* Статус: В ожидании (id = 2) — оранжевый */
.status--pending {
  background-color: #fff7ed;
  color: #f97316;
}

/* Статус: Подтверждено (id = 3) — зелёный */
.status--confirmed {
  background-color: #dcfce7;
  color: #16a34a;
}

/* Статус: Отклонено (id = 4) — красный */
.status--rejected {
  background-color: #fee2e2;
  color: #dc2626;
}
}
.line{
    border-top: 1px solid #0000001A;
    width: 100%;
}
</style>